export const ServicePromoFareIntervals = {
  MONTH: 'month',
  YEAR: 'year',
  WEEKLY: 'week',
  DAY: 'day'
}

export const ServicePromoFareIntervalOptions = [
  {
    value: ServicePromoFareIntervals.YEAR,
    label: 'Year'
  },
  {
    value: ServicePromoFareIntervals.MONTH,
    label: 'Month'
  },
  {
    value: ServicePromoFareIntervals.WEEKLY,
    label: 'Week'
  },
  {
    value: ServicePromoFareIntervals.DAY,
    label: 'Day'
  }
]



// WEBPACK FOOTER //
// ./src/constants/service-promo-fare.ts